import Vue from 'vue'

class PurchaseOrderRuleRepository {
    search(data) {
        return new Promise((resolve, reject) => {
            Vue.auth.fetch({
                url: '/api/invoice/purchase-order-rules/search',
                method: 'post',
                data,
            })
                .then(response => {
                    resolve(response.data)
                }).catch(err => {
                reject(err)
            })
        })
    }

    create(data) {
        return new Promise((resolve, reject) => {
            Vue.auth.fetch({
                url: '/api/invoice/purchase-order-rules/create',
                method: 'post',
                data,
            })
                .then(response => {
                    resolve(response.data)
                }).catch(err => {
                reject(err)
            })
        })
    }

    update(id, data) {
        return new Promise((resolve, reject) => {
            Vue.auth.fetch({
                url: '/api/invoice/purchase-order-rules/update/' + id,
                method: 'put',
                data,
            })
                .then(response => {
                    resolve(response.data)
                }).catch(err => {
                reject(err)
            })
        })
    }

    delete(id) {
        return new Promise((resolve, reject) => {
            Vue.auth.fetch({
                url: '/api/invoice/purchase-order-rules/delete/' + id,
                method: 'delete',
            })
                .then(response => {
                    resolve(response.data)
                }).catch(err => {
                reject(err)
            })
        })
    }
}

export default new PurchaseOrderRuleRepository()